export default __webpack_public_path__ + "static/media/sadhguru_mobile.ef062ba8.jpg";